import { render } from "./Event.vue?vue&type=template&id=49814824&ts=true"
import script from "./Event.vue?vue&type=script&lang=ts"
export * from "./Event.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/tc-admin/tc-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__